<template>
  <div
    class="payment-processing-container"
  >
    <BaseProgressCircular
      indeterminate
      color="#444CE7"
    />
    <div>
      <h1 class="text-lg text-semibold title">
        <slot />
      </h1>
      <span class="text-md text-regular">Please do not refresh or leave this page.</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.payment-processing-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: spacings-get(6);
  height: 100%;
  color: colors-get(gray, 600);

  .title {
    color: colors-get(gray, 900);
  }
}
</style>